import { useCallback } from 'react';

import { TradeBustNotification } from '#/api/ws/ws';

import { useWalletView } from '#/features/wallet/wallet-context';

import useWSListener from '#/utils/useWSListener';

import { publishNotification } from './topic';

export function useTradeBustNotifications() {
  useTradeBustsListener();
}

function useTradeBustsListener(): void {
  const walletView = useWalletView();

  const isReady = walletView.isSignedIn;
  const channel = 'tradebusts';

  const handleWSNotification = useCallback((notif: TradeBustNotification) => {
    const bust = notif.data;

    publishNotification({
      kind: 'trade-bust',
      props: { bust },
    });
  }, []);

  useWSListener<TradeBustNotification>({
    channel,
    isReady,
    handleWSNotification,
  });
}
